import { create } from 'zustand'
import {createJSONStorage, devtools, persist} from 'zustand/middleware'

interface SessionState {
    currentPage: string
    nextPage: string
    isFinish: boolean
    currentPageUpdate: (page: string) => void
    nextPageUpdate: (page: string) => void
    setIsFinish: (bool: boolean) => void
    prevPathType: number | null
    prevPathTypeUpdate: (prevPathType: number) => void
}

const useSessionStore = create<SessionState>()(
    devtools(
        persist(
            (set) => ({
                currentPage: 'none',
                nextPage: 'none',
                isFinish: false,
                currentPageUpdate: (page) => set((state) => ({ currentPage: page })),
                nextPageUpdate: (page) => set((state) => ({ nextPage: page })),
                setIsFinish: (isFinish) => set((state) => ({ isFinish: isFinish })),
                prevPathType: null,
                prevPathTypeUpdate: (curPathType) => set((state) => ({ prevPathType: curPathType })),
            }),
            {
                name: 'SessionStore',
                storage: createJSONStorage(() => sessionStorage)
            },
        ),
    ),
)

interface LocalState {
    guide_expirationDate: Date | null
    guide_expirationDateUpdate: (date: Date) => void
    hiddenGuideList : string[]
    hiddenGuideListUpdate: (list: string[]) => void
}

const useLocalStore = create<LocalState>()(
    devtools(
        persist(
            (set) => ({
                guide_expirationDate: null,
                guide_expirationDateUpdate: (date) => set((state) => ({ guide_expirationDate: date })),
                hiddenGuideList: [],
                hiddenGuideListUpdate: (list) => set((state) => ({ hiddenGuideList: list })),
            }),
            {
                name: 'LocalStore',
                storage: createJSONStorage(() => localStorage)
            },
        ),
    ),
)

export const useCurrentPage = () =>
    useSessionStore((state) => state.currentPage)

export const useCurrentPageUpdate = () =>
    useSessionStore((state) => state.currentPageUpdate)

export const useNextPage = () =>
    useSessionStore((state) => state.nextPage)

export const useNextPageUpdate = () =>
    useSessionStore((state) => state.nextPageUpdate)

export const useGuideExpirationDate = () =>
    useLocalStore((state) => state.guide_expirationDate)

export const useGuideExpirationDateUpdate = () =>
    useLocalStore((state) => state.guide_expirationDateUpdate)

export const useHiddenGuideList = () =>
    useLocalStore((state) => state.hiddenGuideList)

export const useHiddenGuideListUpdate = () =>
    useLocalStore((state) => state.hiddenGuideListUpdate)

export const useIsFinish = () =>
    useSessionStore((state) => state.isFinish)

export const useSetIsFinish = () =>
    useSessionStore((state) => state.setIsFinish)

export const usePrevPathType = () =>
    useSessionStore((state)=>state.prevPathType)

export const usePrevPathTypeUpdate = () =>
    useSessionStore((state)=>state.prevPathTypeUpdate)